import { Section } from '@/components/Section'
import { LoginForm } from '@/containers/LoginForm'
import { useAuth } from '@/context/AuthContext'
import { Container } from '@chakra-ui/react'
import { useReturnUrlNavigate } from 'BrokerTsLib/src/hooks/useReturnUrlNavigate'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router'


export const AdminLoginPage = () => {
  const [searchParams] = useSearchParams()
  const returnUrl = searchParams.get('returnUrl') ?? undefined
  const error = searchParams.has('error')
  
  const returnUrlNavigate = useReturnUrlNavigate()
  const { user, isLogged, isLoading } = useAuth()
  useEffect(() => {
    if (user?.logged && !isLoading) {
      returnUrlNavigate(returnUrl ?? '/')
    }
  }, [user, isLoading, isLogged, returnUrl, returnUrlNavigate])

  return (
    <Section variant="login">
      <Container>
        <LoginForm returnUrl={returnUrl} error={error} />
      </Container>
    </Section>
  )
}
